// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/shop/daily_bg_idle.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-item-filter-container {
    position: absolute;
    top: 2px;
    right: 16px;
    z-index: 10;
}

.shop-item-filter-title {
    background-color: #1c2b38;
    border: 1px solid #227d7d;
    padding: 6px 18px;
    border-radius: 4px;
    color: #FFFFFF;
    text-align: center;
    position: relative;
    cursor: pointer;
}

.shop-filter-list {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    position: absolute;
    top: 36px;
    right: 10px;
    padding: 8px 6px;
    padding-bottom: 12px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.shop-filter-list ul {
    margin: 0;
    padding-left: 0;
    min-width: 132px;
    color: #FFFFFF;
}

.shop-filter-list ul li {
    list-style-type: none;
    padding: 4px 8px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
}

.shop-filter-list ul li:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
}

.shop-filter-list ul li img {
    width: 14px;
    height: 10px;
}

.shop-filter-list ul li span {
    flex: 1;
    text-align: center;
}

.shop-filter-slots-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.shop-filter-slots {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px 6px;
    padding: 4px 6px;
}

.shop-filter-slot {
    display: flex;
    align-items: center;
    gap: 4px;
}

.shop-filter-slot img {
    width: 14px;
    height: 14px;
}

.shop-filter-divider {
    width: 90%;
    height: 1px;
    background-color: #415567;
}`, "",{"version":3,"sources":["webpack://./src/components/shopItemFilter/ShopItemFilter.style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B","sourcesContent":[".shop-item-filter-container {\n    position: absolute;\n    top: 2px;\n    right: 16px;\n    z-index: 10;\n}\n\n.shop-item-filter-title {\n    background-color: #1c2b38;\n    border: 1px solid #227d7d;\n    padding: 6px 18px;\n    border-radius: 4px;\n    color: #FFFFFF;\n    text-align: center;\n    position: relative;\n    cursor: pointer;\n}\n\n.shop-filter-list {\n    background-image: url('@assets/shop/daily_bg_idle.png');\n    background-size: 100% 100%;\n    position: absolute;\n    top: 36px;\n    right: 10px;\n    padding: 8px 6px;\n    padding-bottom: 12px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: 10;\n}\n\n.shop-filter-list ul {\n    margin: 0;\n    padding-left: 0;\n    min-width: 132px;\n    color: #FFFFFF;\n}\n\n.shop-filter-list ul li {\n    list-style-type: none;\n    padding: 4px 8px;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 4px;\n}\n\n.shop-filter-list ul li:hover {\n    text-decoration: underline;\n    text-underline-offset: 2px;\n}\n\n.shop-filter-list ul li img {\n    width: 14px;\n    height: 10px;\n}\n\n.shop-filter-list ul li span {\n    flex: 1;\n    text-align: center;\n}\n\n.shop-filter-slots-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.shop-filter-slots {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    gap: 4px 6px;\n    padding: 4px 6px;\n}\n\n.shop-filter-slot {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.shop-filter-slot img {\n    width: 14px;\n    height: 14px;\n}\n\n.shop-filter-divider {\n    width: 90%;\n    height: 1px;\n    background-color: #415567;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
